import { render, staticRenderFns } from "./integrationAdd.vue?vue&type=template&id=f0d42680&scoped=true&"
import script from "./integrationAdd.vue?vue&type=script&lang=js&"
export * from "./integrationAdd.vue?vue&type=script&lang=js&"
import style0 from "./integrationAdd.vue?vue&type=style&index=0&id=f0d42680&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d42680",
  null
  
)

export default component.exports